<app-view-title Title="{{ labels.title }}" [isSplitColor]="true"></app-view-title>
<view-content [centered]="true">
  <app-customer-form-component #frmCustomer class="row" [(customer)]="customer" [hideFields]="['Email', 'MobilePhone']">
  </app-customer-form-component>
  @if(customer || Settings.clientSettings.RequireSignIn)
  {
  <h6>{{ 'Intellitrailer.Setup.Customer.label_' + labels.gdpr | translate : labels.gdpr}}</h6>
  <div class="row">
    <a class="col-10" (click)="showTerms()" [disabled]="!hasGDPR">{{ labels.confirmGdpr }}</a>
    <mat-checkbox class="col-2" labelPosition="before" [(ngModel)]="confirmGDPR"></mat-checkbox>
  </div>
  }

</view-content>
  <view-actions>
    <button mat-raised-button (click)="next(frmCustomer.validate())">
      {{ labels.next }}
    </button>
  </view-actions>
